import { Action } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { createAction } from 'shared/util/utility';
import * as actionTypes from './action-types';

const activePrimaryOverviewPanel = (isPrimaryPanelVisible: boolean) => {
	return async (dispatch: ThunkDispatch<{}, {}, Action>) => {
		dispatch(createAction(actionTypes.SET_PRIMARY_OVERVIEW_PANEL_VISIBLE, isPrimaryPanelVisible));
	};
};

export { activePrimaryOverviewPanel };
